import { dscvrIcApi } from '@/shared/api';
import type { UpdateUserEmail } from 'dfx/edge/edge.did';

export const useSetUserEmailMutation = (email: UpdateUserEmail) => {
  return dscvrIcApi.userSettings.setUserEmail(email);
};
